import { render, staticRenderFns } from "./FormComplementaireWinpaie.vue?vue&type=template&id=5fb4d706&"
import script from "./FormComplementaireWinpaie.vue?vue&type=script&lang=js&"
export * from "./FormComplementaireWinpaie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports